module.exports = __webpack_public_path__ + "img/clound-pic.903deada.png";